import Info360InsightBanner from '@Components/AboutBoxBanner';
import { ThemeStylesProvider, UnsupportedBrowserPrompt } from '@innovyze/stylovyze';
import { ASSET_SUBSCRIPTIONS } from '@innovyze/shared-utils';
import {
	AboutBoxProps,
	ApplicationWrapper,
	RegisteredApplications,
	STYLOVYZE_FLAGS,
	aboutBoxTextWithStylesV1,
	useIsFeatureEnabled,
	useNotificationHubConfig,
} from '@innovyze/stylovyze';
import cookies from 'browser-cookies';
import { detect } from 'detect-browser';
import 'devextreme/dist/css/dx.common.css';
import React from 'react';
import './App.css';
import { globalization } from './i18n/globalization';
import { useGlobalization } from './i18n/useGlobalization';
import usePages from './routes/usePages';
import './theme/innovyze-theme-devextreme.css';
import { parseBoolean } from './utils/parseBoolean';

declare module '@innovyze/stylovyze';
function App() {
	const { t } = useGlobalization();
	const browser = detect();
	const [userAcceptsUnsupported, setUserAcceptsUnsupported] =
		React.useState<boolean>(
			parseBoolean(cookies.get('userAcceptsUnsupported')),
		);

	const isChatbotEnabled = !!useIsFeatureEnabled(
		'i360a-enableFlowGPT-framed',
	);

	// TODO : To add a new module npm install the module then add to dm.index.d.ts, store.tsx, routes/pages.tsx, routes/usePages.tsx
	const pages = usePages();

	const isAboutBoxEnabled = !!useIsFeatureEnabled(
		STYLOVYZE_FLAGS.ASSET_ABOUT_BOX,
	);

	const isSharedWorkersEnabled = !!useIsFeatureEnabled(
		STYLOVYZE_FLAGS.SESSION_SHARED_WORKERS,
	);

	const notificationHub = useNotificationHubConfig('info360-asset');

	const aboutBox = isAboutBoxEnabled
		? ({
				title: t('About Info360'),
				banner: <Info360InsightBanner />,
				textBoxContent: aboutBoxTextWithStylesV1,
		  } as Omit<AboutBoxProps, 'open' | 'setOpen'>)
		: undefined;

	if (
		!userAcceptsUnsupported &&
		browser &&
		browser.name !== 'chrome' &&
		browser.name !== 'edge-chromium'
	) {
		return (
			<ThemeStylesProvider>
				<UnsupportedBrowserPrompt
					onUserAcceptsUnsupported={() => {
						cookies.set('userAcceptsUnsupported', 'true');
						setUserAcceptsUnsupported(true);
					}}
				/>
			</ThemeStylesProvider>
		);
	}
	return (
		<ApplicationWrapper
			validateTerms
			pages={pages}
			globalization={globalization}
			expiredSubscriptionsSet={ASSET_SUBSCRIPTIONS}
			helpUrl={'https://help.autodesk.com/view/INF360A/ENU/'}
			applicationContext={{
				applicationName: RegisteredApplications.APP_AM_MAIN,
			}}
			aboutBox={aboutBox}
			loginPicker
			notificationHub={notificationHub}
			withHelpbot={isChatbotEnabled}
			hasSharedWorkers={isSharedWorkersEnabled}
		/>
	);
}

export default App;
